import { PAGE_LIMIT } from "helpers/viewContent";
import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { useDispatch } from "react-redux";
import {
  getAdminValidityApi_,
  getAdminValidityApiSecond_,
  getDashboardApiCalls_,
} from "store/services/dashboardService";
import ApiStats from "./ApiStats";
import BasicLineChart from "./AccessGraph";
import SlowestApiComponent from "./SlowestApi";
import TableData from "./TableDataTotal_API_Call_LIST";
import CountryDataGraph from "./CountriesDataGraph";
import TopIpGraph from "./TOpIpGraph";
import ResponseCodeStatus from "./ResponseCodeGraph";
import FourEndpointError from "./FourEndpointErrorGraph";
import { postData_ } from "helpers/Helper";
import { GET_API_PROGRESS_BAR_DATA } from "store/services/apiPath";

const DashboardApiIndex = () => {
  const today = new Date();
  const formattedDate = `${String(today.getMonth() + 1).padStart(
    2,
    "0"
  )}-${String(today.getDate()).padStart(2, "0")}-${today.getFullYear()}`;
  const formattedMonth = today.toLocaleString("default", { month: "long" });
  const formattedYear = today.getFullYear();
  const [progressBarData, setProgressBarData] = useState([]);
  const [apiData, setApiDate] = useState({});
  const [apiValidityData, setApiValidityData] = useState({});
  const [apiValidityDataSecond, setApiValidityDataSecond] = useState({});

  const dispatch = useDispatch();

  const [filter, setFilter] = useState({
    page: 1,
    limit: PAGE_LIMIT,
    search: "",
    status: "",
    order: -1,
    orderBy: "createdAt",
  });

  const fetchData = async () => {
    try {
      let query = {};
      let res = await dispatch(getDashboardApiCalls_(query));
      setApiDate(res?.data?.data);
    } catch (err) {
      console.log(err);
    }
  };
  const fetchValidityData = async () => {
    try {
      let res = await dispatch(getAdminValidityApi_({}));
      let res1 = await dispatch(getAdminValidityApiSecond_({}));
      setApiValidityData(res?.data?.data);
      setApiValidityDataSecond(res1?.data?.data);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchProgressBarData = async () => {
    try {
      const res = await postData_(`${GET_API_PROGRESS_BAR_DATA}`);
      console.log(res?.data, "res?.data?.success");
      if (res?.data?.status === "success") {
        setProgressBarData((p) => res?.data?.data || []);
      }
    } catch (error) {}
  };

  console.log(progressBarData, "progressBarData");

  useEffect(() => {
    fetchData();
    fetchValidityData();
    fetchProgressBarData();
  }, []);

  return (
    <Container fluid>
      <hr />
      <Row className="mb-4">
        <Col md={6}>
          <Card className="cardDesign">
            <Card.Body>
              <h5 className="mb-4">Summary</h5>
              <div className="d-flex justify-content-between">
                <p>Total User Using Api:</p>
                <p>{apiData?.SumeryData?.TotalUserUsingApi || 0} User</p>
              </div>
              <div className="d-flex justify-content-between">
                <p>Total User Requesting Api Key:</p>
                <p>{apiData?.SumeryData?.TotalHitsApiKey || 0} User </p>
              </div>
              <div className="d-flex justify-content-between">
                <p>{`User With > 50 Api Call /week`} :</p>
                <p>{apiData?.SumeryData?.Total_API_50_Api || 0} User</p>
              </div>
              <div className="d-flex justify-content-between">
                <p>{`User With < 10 Api Call /week`} :</p>
                <p>{apiData?.SumeryData?.Total_API_10_Api || 0} User</p>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col md={6}>
          <Card className="cardDesign">
            <Card.Body>
              <h5 className="mb-4">Total Api Call</h5>
              <div className="d-flex justify-content-between">
                <p>Today({formattedDate}) :</p>
                <p>{apiData?.Total_API_Call?.today || 0}</p>
              </div>
              <div className="d-flex justify-content-between">
                <p>This Month({formattedMonth}) :</p>
                <p>{apiData?.Total_API_Call?.thisMonth || 0}</p>
              </div>
              <div className="d-flex justify-content-between">
                <p>This Year({formattedYear}) :</p>
                <p>{apiData?.Total_API_Call?.thisYear || 0}</p>
              </div>
              <div className="d-flex justify-content-between">
                <p>Lifetime:</p>
                <p>{apiData?.Total_API_Call?.lifetime || 0}</p>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <hr />
      <Row className="mb-4">
        <Col md={6}>
          <Card className="cardDesign">
            <Card.Body>
              <h5 className="mb-4">Top API Calls</h5>
              <div className="d-flex justify-content-between">
                <p>Api</p>
                <p>Count</p>
              </div>
              {apiData?.Total_API_Call_LIST?.length > 0 ? (
                apiData.Total_API_Call_LIST.map((list, i) => (
                  <div className="d-flex justify-content-between" key={i}>
                    <p>
                      {i + 1}. {list?._id.replace("/api/v1/tradingApis", "")}
                    </p>
                    <p>{list?.count}</p>
                  </div>
                ))
              ) : (
                <p>No Data Found</p>
              )}
            </Card.Body>
          </Card>
        </Col>
        <Col md={6}>
          <Card className="cardDesign">
            <Card.Body>
              <h5 className="mb-4">Top User Api Call</h5>
              <div className="d-flex justify-content-between">
                <p>User</p>
                <p>Api Calls</p>
              </div>
              {apiData?.Total_User_Api_Call_Count?.length > 0 ? (
                apiData.Total_User_Api_Call_Count.map((list, i) => (
                  <div className="d-flex justify-content-between" key={i}>
                    <p>
                      {i + 1}. {list?.username || "N/A"}
                    </p>
                    <p>{list?.totalCalls} Api Call</p>
                  </div>
                ))
              ) : (
                <p>No Data Found</p>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row className="mb-4">
        <hr />
        <Col md={6}>
          <Card className="cardDesign">
            <Card.Body>
              <h5 className="mb-4">
                Latency, Unique Users, Requests, Failures
              </h5>
              <ApiStats
                latency={apiValidityData?.avgLatency}
                failures={apiValidityData?.failures}
                uniqueUsers={apiValidityData?.uniqueUsers}
                totalRequests={apiValidityData?.totalRequests}
              />
            </Card.Body>
          </Card>
        </Col>
        <Col md={6}>
          <Card className="cardDesign">
            <Card.Body>
              <h5 className="mb-2">Total API Access Graph</h5>
              <BasicLineChart accessGraph={apiValidityData?.accessGraph} />
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row className="mb-4">
        <hr />
        <Col md={6}>
          <Card className="cardDesign">
            <Card.Body>
              <h5 className="mb-2">Top Slowest APIs</h5>
              <SlowestApiComponent slowestApi={apiValidityData?.slowestAPIs} />
            </Card.Body>
          </Card>
        </Col>
        <Col md={6}>
          <Card className="cardDesign">
            <Card.Body>
              <h5 className="mb-2">Newest 4xx Errors</h5>
              <TableData
                userListing={apiValidityData?.newest4xx}
                setFilter={setFilter}
                filter={filter}
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row className="mb-4">
        <hr />
        <Col md={6}>
          <Card className="cardDesign">
            <Card.Body>
              <h5 className="mb-4">Top Countries</h5>
              <CountryDataGraph
                TopCountries={apiValidityDataSecond?.Top_Countries}
              />
            </Card.Body>
          </Card>
        </Col>
        <Col md={6}>
          <Card className="cardDesign">
            <Card.Body>
              <h5 className="mb-2">Top IPs</h5>
              <TopIpGraph IPSourceApiCall={apiValidityDataSecond?.Top_ips} />
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row className="mb-4">
        <hr />
        <Col md={6}>
          <Card className="cardDesign">
            <Card.Body>
              <h5 className="mb-2">By Response Status Code</h5>
              <ResponseCodeStatus
                responseStatusCodes={
                  apiValidityDataSecond?.Response_Status_Code
                }
              />
            </Card.Body>
          </Card>
        </Col>
        <Col md={6}>
          <Card className="cardDesign">
            <Card.Body>
              <h5 className="mb-2">4xx Errors by Endpoint</h5>
              <FourEndpointError
                errorData={apiValidityDataSecond?.fourxx_Errors_by_Endpoint}
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <Card className="cardDesign">
            <Card.Body>
              <h5 className="mb-2">Api Monitoring</h5>

              <div
                style={{
                  maxHeight: 500,
                  overflowY: "scroll",
                }}
                className="px-4"
              >
                {progressBarData?.map((item, index) => {
                  return (
                    <div>
                      <label className="py-2 d-flex  ">
                        <span>{item?.endpoint} </span>
                      </label>
                      <div
                        class="progress px-0"
                        style={{
                          height: 20,
                        }}
                      >
                        <div
                          class="progress-bar progress-bar-striped progress-bar-animated api-progress-bar"
                          role="progressbar"
                          aria-valuenow="75"
                          aria-valuemin="0"
                          aria-valuemax="100"
                          style={{
                            width: item?.uptime_percentage + "%",
                            backgroundColor: "#02B2AF",
                          }}
                        ></div>
                      </div>
                      <div className="d-flex justify-content-between align-items-center">
                        <hr style={{ width: "45%", height: 3 }}></hr>
                        {item?.uptime_percentage} %
                        <hr style={{ width: "45%", height: 3 }}></hr>
                      </div>
                    </div>
                  );
                })}
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default DashboardApiIndex;
